namespace RedBullMOBILE360.Utilities {
    export interface ReAuthenticateNumbersRow {
        Id?: number;
        Msisdn?: string;
        IdNumber?: string;
        IdType?: number;
        Nationality?: number;
        TccRequest?: string;
        TccResponse?: string;
        BssRequest?: string;
        BssResponse?: string;
        OperationType?: string;
        Status?: string;
        TccIdNumber?: string;
        CreationDate?: string;
        FirstName?: string;
        LastName?: string;
        Iccid?: string;
        IamOtp?: string;
        IsMnp?: number;
        PrepostPaid?: number;
        IsEsim?: number;
    }

    export namespace ReAuthenticateNumbersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Msisdn';
        export const localTextPrefix = 'Utilities.ReAuthenticateNumbers';
        export const deletePermission = 'Utilities:ReAuthenticateNumbers';
        export const insertPermission = 'Utilities:ReAuthenticateNumbers';
        export const readPermission = 'Utilities:ReAuthenticateNumbers';
        export const updatePermission = 'Utilities:ReAuthenticateNumbers';

        export declare const enum Fields {
            Id = "Id",
            Msisdn = "Msisdn",
            IdNumber = "IdNumber",
            IdType = "IdType",
            Nationality = "Nationality",
            TccRequest = "TccRequest",
            TccResponse = "TccResponse",
            BssRequest = "BssRequest",
            BssResponse = "BssResponse",
            OperationType = "OperationType",
            Status = "Status",
            TccIdNumber = "TccIdNumber",
            CreationDate = "CreationDate",
            FirstName = "FirstName",
            LastName = "LastName",
            Iccid = "Iccid",
            IamOtp = "IamOtp",
            IsMnp = "IsMnp",
            PrepostPaid = "PrepostPaid",
            IsEsim = "IsEsim"
        }
    }
}
